export default "<div class=\"chart-container\">\r\n  <canvas id=\"sentimentChart\">{{ chart }}</canvas>\r\n</div>\r\n";